import { useCallback } from 'react';
import { openPredefinedStepRulesInSingleObjectScreen } from '../../../../reducers/documentation/documentationReducer';
import { useDispatch } from 'react-redux';
import { DocumentationTabTypes } from '../../../../types/enums/DocumentationTabTypes';
import {
  setTopBarSearchText,
  setTopBarSort,
} from '../../../../reducers/documentation/documentationTopBarReducer';
import { SortOrder } from '../../../common/types';

export const useTabFiltersFunctions = () => {
  const dispatch = useDispatch();

  const setSearchTxt = useCallback(
    (searchTxt: string) => {
      dispatch(setTopBarSearchText({ searchText: searchTxt }));
    },
    [dispatch],
  );

  const registerSortChange = useCallback(
    ({ sortKey, sortOrder }: { sortKey: string; sortOrder: string }) => {
      dispatch(setTopBarSort({ sort: { sortBy: sortKey, sortOrder: sortOrder as SortOrder } }));
    },
    [dispatch],
  );

  const registerPredefinedFilters = useCallback(
    (props: {
      singleObjectApiName: string;
      selectedStepName?: string;
      selectedRecordTypeValue?: string;
      defaultActiveTab: DocumentationTabTypes;
      objects?: ObjectTypeName[];
    }) => {
      dispatch(openPredefinedStepRulesInSingleObjectScreen(props));
    },
    [dispatch],
  );

  return {
    registerSortChange,
    setSearchTxt,
    registerPredefinedFilters,
  };
};
